import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/button.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/label.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import './styles.scss'
import { Scenario } from 'components/scenario'
import './styles.scss'

export class Aerosolembed extends React.Component<Props, State> {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className='aerosol-embed'>
        <h5>So lange überlebt das neue Coronavirus in der Luft</h5>
        <p>
          Mit einem Berechnungsmodell von US-Wissenschaftlern kann jeder selber
          die Infektionsdauer der Viren in der Luft berechnen. Der{' '}
          <a
            href='https://www.dhs.gov/science-and-technology/sars-airborne-calculator'
            target='_blank'
          >
            Sars-Airbone-Calculator
          </a>{' '}
          zeigt anhand von Faktoren wie UV-Strahlung (Sonnenlicht),
          Luftfeuchtigkeit und Temperatur wie lange es dauert, bis 90 Prozent
          aller Sars-CoV-2-Viren zerfallen sind. 6 Beispiele:
        </p>
        <div className='chart'>
          <div className='legend'>
            <div className='key left'>
              <img src={require('./images/uv.svg')} className='ui image' />
              UV-Index
              <br />
              (1–11)
            </div>
            <div className='key middle'>
              <img src={require('./images/temp.svg')} className='ui image' />
              Temperatur
            </div>
            <div className='key right'>
              <img src={require('./images/humid.svg')} className='ui image' />
              Luftfeuchtigkeit
            </div>
          </div>

          <div className='ui equal width center aligned padded grid'>
            <div className='row'>
              <div className='column'>
                <Scenario
                  title='Frühling, draussen'
                  uv='4'
                  temp='14'
                  humid='70'
                  time='19min'
                />
              </div>
              <div className='column'>
                <Scenario
                  title='Sommer, draussen'
                  uv='7'
                  temp='30'
                  humid='70'
                  time='8min 30s'
                />
              </div>
            </div>

            <div className='row'>
              <div className='column'>
                <Scenario
                  title='Sommer, drinnen'
                  uv='0'
                  temp='23'
                  humid='45'
                  time='2h 24min'
                />
              </div>
              <div className='column'>
                <Scenario
                  title='Herbst, draussen'
                  uv='3'
                  temp='16'
                  humid='70'
                  time='23min'
                />
              </div>
            </div>

            <div className='row'>
              <div className='column'>
                <Scenario
                  title='Winter, draussen'
                  uv='1'
                  temp='10'
                  humid='70'
                  time='1h 2min'
                />
              </div>
              <div className='column'>
                <Scenario
                  title='Winter, drinnen'
                  uv='0'
                  temp='21'
                  humid='35'
                  time='5h 9min'
                />
              </div>
            </div>
          </div>
        </div>
        <div className='foot'>
          <p className='source'>
            Quelle:{' '}
            <a
              href='https://academic.oup.com/jid/article/222/4/564/5856149'
              target='_blank'
            >
              The Journal of Infectious Diseases
            </a>
          </p>
        </div>
      </div>
    )
  }
}

export default Aerosolembed
